import React, { Component } from 'react'
import DropZone from 'react-dropzone'
import { connect } from 'react-redux'
import { animateScroll } from 'react-scroll'

import {
  buyHelper,
  getCompassDocumentiList,
  getCompassDocumentiListCallback,
  phaseChange,
  postCompassCongrats,
  reroute,
  storeDumpItForce,
  toggleHelpDocumenti,
} from '../../../actions/Buy'
import {
  compassFileUploadDropped,
  compassFileUploadRemoved,
  postCompassFileUpload,
} from '../../../actions/buy/Documenti'
import fbPixel, { FB_EVENTS } from '../../../utils/fbpixel'
import OrderRecoveryBanner from '../../dumb/OrderRecoveryBanner'
import DocumentiHelper from '../../noleggia/dumb/DocumentiHelper'
import triggerDataLayerEvent, { GA_EVENTS } from '../../triggerDataLayerEvent'
import BuyHelpFinancementDocuments from '../dumb/BuyHelpFinancementDocuments'
import BuyModal from '../dumb/BuyModal'
import BuyPleaseWait from '../dumb/BuyPleaseWait'

class DocumentsCompass extends Component {
  constructor(props) {
    super(props)
    this.state = {}
    this.state.uploadInProgress = false
    this.state.toTop = false
    this.onOpenClick = this.onOpenClick.bind(this)
    this.onDrop = this.onDrop.bind(this)
    this.handleSubmit = this.handleSubmit.bind(this)
    this.removeFile = this.removeFile.bind(this)
    this.handleHelper = this.handleHelper.bind(this)
    this.buildListaDocumentiSelezionatiPerUpload =
      this.buildListaDocumentiSelezionatiPerUpload.bind(this)
    this.state.upload_btn_disabled = true
  }

  componentWillMount() {
    if (
      !('token' in this.props.customer) ||
      this.props.customer.token === null ||
      this.props.customer.token.length === 0
    ) {
      this.props.reroute('/register', true)
    }
  }

  shouldComponentUpdate(nextProps, nextState) {
    // eslint-disable-next-line
    for (const key in nextState) {
      if (nextState[key] !== this.state[key]) {
        return true
      }
    }
    // eslint-disable-next-line
    for (const key in nextProps) {
      if (nextProps[key] !== this.props[key]) {
        return true
      }
    }
    return false
  }

  componentDidMount() {
    this.props.phaseChange({ phase: 50 })

    if (!this.state.toTop) {
      animateScroll.scrollToTop()
      this.setState({ toTop: true })
    }

    const t = this

    t.props
      .getCompassDocumentiList({
        uri: `${window.brumbrum.url_api}/compass/t/v1/clienti/${t.props.ordine.id_ordine}/documenti`,
        method: 'GET',
        token: this.props.customer.token,
        callback: t.props.getCompassDocumentiListCallback,
      })
      .then(() => {
        t.props.storeDumpItForce()
      })
      .catch(() => null)

    // BRUM-6741 si mostra subito l'help di come far le foto ai documenti
    setTimeout(() => this.props.toggleHelpDocumenti(true), 3000)
  }

  removeFile() {
    const that = this
    return function (e) {
      e.preventDefault()
      e.stopPropagation()
      that.props.compassFileUploadRemoved(e.target.id.replace('remove-', ''))
      if (that.props.compassFileUpload.dropzone.length === 0) {
        that.setState({ upload_btn_disabled: true })
      }
    }
  }

  onDrop(acceptedFiles) {
    if (this.state.upload_btn_disabled) {
      this.setState({ upload_btn_disabled: acceptedFiles.length <= 0 })
    }
    this.props.compassFileUploadDropped({ dropzone: acceptedFiles })
  }

  onOpenClick(event) {
    event.stopPropagation()
    event.preventDefault()
    this.dropzone.open()
  }

  handleHelper() {
    this.props.buyHelper()
  }

  handleSubmit() {
    const t = this
    // BRUM-5806 reroute senza parametri fa solo il check disponibilita
    t.props.reroute().then(() => {
      if (!t.props.fetching) {
        if (!t.state.upload_btn_disabled) {
          t.setState({ uploadInProgress: true })
          t.props
            .postCompassFileUpload({
              dropzone: t.props.compassFileUpload.dropzone,
              token: t.props.customer.token,
              id_ordine: t.props.ordine.id_ordine,
            })
            .then(() => {
              t.props
                .postCompassCongrats({
                  token: t.props.customer.token,
                  method: 'POST',
                  uri: `${window.brumbrum.url_api}/compass/t/v1/finanziamenti/${t.props.ordine.id_ordine}`,
                })
                .then(() => {
                  fbPixel(FB_EVENTS.Purchase, t.props.product)
                  triggerDataLayerEvent(GA_EVENTS.Purchase_finanziamento)
                  t.setState({ uploadInProgress: false })
                  t.props.phaseChange({
                    last: t.props.ui.last > 50 ? t.props.ui.last : 50,
                  })
                  t.props.reroute('/thank-you', true)
                })
                .catch(() => null)
            })
            .catch(() => {
              t.setState({ uploadInProgress: false })
            })
        }
      }
    })
  }

  buildListaDocumentiNecessari() {
    const t = this
    return t.props.compassFileUpload.documenti_necessari.map((documento, i) => (
      <li key={i}>
        <span className="document_name">
          <label className="r-checkbox">
            <input type="checkbox" />
            {/* <span className="check"></span> */}
            {documento.label}
            <a className="upload-mobile">
              <i className="icon-arrow_double_right"></i>
            </a>
          </label>
        </span>
      </li>
    ))
  }

  buildListaDocumentiSelezionatiPerUpload() {
    const t = this
    return t.props.compassFileUpload.dropzone.map((documento, i) => (
      <li key={i}>
        <div className={'file_preview'}>
          <img src={documento.preview} />
        </div>
        <div className={'file_link'}>
          <a
            className={'file_link--label'}
            href={documento.preview}
            rel="noreferrer"
            target="_blank"
          >
            {documento.name}
          </a>
        </div>
        <span className={'file_remove'}>
          <a className="file_remove--link" onClick={this.removeFile()}>
            {' '}
            <i className="icon-close file_remove--icon" id={`remove-${i}`}></i>
          </a>
        </span>
      </li>
    ))
  }

  render() {
    return (
      <div>
        <div className="process__header hide-print">
          <h1 className="process__title hide-print">Carica i tuoi documenti</h1>
          <p className="process__intro hide-print">
            Aiutaci a raccogliere i documenti che servono a completare la tua
            richiesta di finanziamento.
          </p>
        </div>
        <div className={'messages warning'}>
          <div className={'container'}>
            <OrderRecoveryBanner />
          </div>
        </div>
        <div className="user-informations">
          <div className="container--small">
            <BuyHelpFinancementDocuments
              helper={this.handleHelper}
              show={this.props.help}
            />

            <div className="documents__upload">
              <div className="documents__upload__left">
                <div className="documents_list">
                  <ul>
                    <li className="title">
                      <span className={'only-desktop'}>
                        Ciao{' '}
                        <span className={'user_name'} data-hj-suppress>
                          {this.props.customer.nome}
                        </span>
                        , carica i seguenti documenti:
                      </span>
                      <span className={'only-mobile'}>
                        Ciao{' '}
                        <span className={'user_name'} data-hj-suppress>
                          {this.props.customer.nome}
                        </span>
                        , ci servono questi documenti:
                      </span>
                    </li>

                    {this.props.compassFileUpload.documenti_necessari.length >
                      0 && this.buildListaDocumentiNecessari()}

                    <li className={'files__list'}>
                      <ul>
                        {this.props.compassFileUpload.dropzone.length > 0 ? (
                          <li className={'title small'}>Documenti caricati:</li>
                        ) : null}
                        {this.props.compassFileUpload.dropzone.length > 0 &&
                          this.buildListaDocumentiSelezionatiPerUpload()}
                      </ul>
                    </li>
                    {this.props.compassFileUpload.dropzone.length > 0 ? (
                      <li className="last">
                        <a
                          className={
                            this.props.fetching ||
                            this.state.upload_btn_disabled
                              ? 'btn btn-primary btn-disabled'
                              : 'btn btn-primary'
                          }
                          onClick={this.handleSubmit}
                        >
                          <span>Avvia richiesta finanziamento</span>
                        </a>
                      </li>
                    ) : null}
                  </ul>
                </div>
              </div>
              <div className="documents__upload__right">
                <DocumentiHelper
                  onClick={() => this.props.toggleHelpDocumenti(true)}
                />

                <DropZone
                  accept="application/pdf,image/jpg,image/jpeg,image/png"
                  activeClassName="drag_accept"
                  className="drag_drop"
                  onDrop={this.onDrop}
                  ref={node => {
                    this.dropzone = node
                  }}
                  rejectClassName="drag_reject"
                >
                  <div className="drag_drop__content">
                    <i className="icon-upload"></i>
                    <h2>Trascina qui i tuoi documenti</h2>
                    <span style={{ fontSize: '12px' }}>
                      (formati consentiti .jpg, .jpeg, .png, .pdf - max 50MB)
                    </span>
                  </div>
                </DropZone>
                <div className="documents__upload__other">
                  <span className="documents__upload__other__or only-desktop">
                    <span>Oppure</span>
                  </span>
                  <div className="file-upload-box">
                    <div
                      className="fileUpload btn btn-secondary"
                      onClick={this.onOpenClick}
                    >
                      <span className={'only-desktop'}>Scegli un file</span>
                      <span className={'only-mobile'}>
                        Carica/Scatta una foto
                      </span>
                      <input className="upload" id="uploadBtn" type="file" />
                    </div>
                    {this.props.compassFileUpload.dropzone.length > 0 ? (
                      <div className="only-mobile">
                        <a
                          className={
                            this.props.fetching ||
                            this.state.upload_btn_disabled
                              ? 'btn btn-primary btn-disabled'
                              : 'btn btn-primary'
                          }
                          onClick={this.handleSubmit}
                        >
                          <span>Avvia richiesta finanziamento</span>
                        </a>
                      </div>
                    ) : null}
                  </div>
                </div>
              </div>
            </div>
            <div className="contacts_list">
              <ul>
                <li className="title">
                  <span>
                    Problemi con l'upload?
                    <br />
                    Chiama il Servizio Clienti allo <b>02.800.29</b>
                  </span>
                </li>
              </ul>
            </div>
          </div>
        </div>
        {this.state.uploadInProgress && (
          <BuyModal>
            <BuyPleaseWait
              h1="Upload in corso"
              p={
                <span>
                  La tua richiesta finanziamento sta per essere inoltrata
                </span>
              }
            />
          </BuyModal>
        )}
      </div>
    )
  }
}

const mapStateToProps = state => ({
  compassFileUpload: state.compassFileUpload,
  customer: state.customer,
  ordine: state.ordine,
  product: state.product,
  fetching: state.ui.fetching,
  ui: state.ui,
  help: state.ui.buyHelper,
})

export default connect(mapStateToProps, {
  postCompassFileUpload,
  compassFileUploadDropped,
  compassFileUploadRemoved,
  postCompassCongrats,
  getCompassDocumentiList,
  getCompassDocumentiListCallback,
  phaseChange,
  storeDumpItForce,
  reroute,
  buyHelper,
  toggleHelpDocumenti,
})(DocumentsCompass)
